module.exports = __webpack_public_path__ + "media/images/icons/icon-explore-article-d5d71964558945cba4a89b4ea4169daf.svg";